import { render, staticRenderFns } from "./DanhGiaKDLDetailList.vue?vue&type=template&id=3454688a&"
import script from "./DanhGiaKDLDetailList.vue?vue&type=script&lang=js&"
export * from "./DanhGiaKDLDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports